import SchedulesPage from "./SchedulesPage";

export default function SchedulesEmployeesPage() {
  return <SchedulesPage view="employee" />;
}
